import { create } from 'zustand';
import { User } from '../types';

interface AuthState {
  user: User | null;
  login: (email: string, password: string) => Promise<boolean>;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  login: async (email: string, password: string) => {
    // Accept any email address and create a default user profile
    if (email && password) {
      const defaultUser: User = {
        id: '1',
        name: email.split('@')[0], // Use the part before @ as the name
        email: email,
        role: 'lawyer',
        avatar: `https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?fit=crop&w=100&h=100`
      };
      set({ user: defaultUser });
      return true;
    }
    return false;
  },
  logout: () => set({ user: null })
}));